import '@/component/style/app.css';

import React, { PropsWithChildren } from 'react';

import * as styles from './plainLayout.css';

export function PlainLayout({ children }: PropsWithChildren) {
  return <div className={styles.plainLayout}>{children}</div>;
}
